<!--
  ~ Copyright (c) 2020. Sayari LLC
  -->

<!-- Navigation -->
<nav id="mainNav" class="navbar navbar-default navbar-fixed-top navbar-custom">
    <div class="container">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
            <div>
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#specklesNavbar">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <a class="logo-font" href="#page-top">speckles</a>
            </div>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="specklesNavbar">
            <ul class="nav navbar-nav navbar-right">
                <li class="hidden">
                    <a href="#page-top"></a>
                </li>
                <li>
                    <a [routerLink]="['/home']" fragment="howitworks" >How It Works</a>
                </li>
                <li>
                    <a [routerLink]="['/home']" fragment="about">About</a>
                </li>
                <li>
                    <a [routerLink]="['/home']" fragment="register">Business Sign Up</a>
                </li>
                <li>
                    <a [routerLink]="['/home']" fragment="socialmedia">Social</a>
                </li>
                <li class="user-sign-up-button">
                    <span><a href="{{url}}" class="btn btn-primary nav-item" target="_blank">View Specials</a></span>
                </li>
            </ul>
        </div>
        <!-- /.navbar-collapse -->
    </div>
    <!-- /.container-fluid -->
</nav>